export default __webpack_public_path__ + "static/media/pg-44.51b9eba6.jpg";